import React from 'react';
import { CloseIcon } from '../icons';

interface ModalTitleProps {
  title: string;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function ModalTitle({ setIsOpen, title }: ModalTitleProps) {
  return (
    <div className="flex justify-between items-center border-b px-6 py-3">
      <h2 className="text-xl text-text-gray font-semibold">{title}</h2>
      <button
        type="button"
        aria-label="close"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(false);
        }}
      >
        <CloseIcon className="h-5 w-5 text-red-500" />
      </button>
    </div>
  );
}

export default ModalTitle;
